/**
 * JSON.stringify with try/catch wrapper
 * @param arg Any
 * @returns String
 */
export const safeStringify = (arg: any): string => {
  let r = '';
  try {
    r = JSON.stringify(arg);
  } catch (e) {}
  return r;
};
